import { LinkingOptions } from "@react-navigation/native";

import { SCREENS, PATHS } from "../consts";

import { RootNavigationParamList } from "./types";

export const LINKING_OPTIONS: LinkingOptions<RootNavigationParamList> = {
  prefixes: [],
  config: {
    initialRouteName: SCREENS.VenueLogin,
    screens: {
      [SCREENS.Login]: PATHS.Login,
      [SCREENS.VenueLogin]: PATHS.VenueLogin,
      [SCREENS.EventList]: PATHS.EventList,
      [SCREENS.Main]: {
        path: PATHS.Main,
        initialRouteName: SCREENS.EventTab,
        screens: {
          [SCREENS.EventTab]: {
            path: PATHS.EventTab,
            // FIXME
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            initialRouteName: SCREENS.EventDetails,
            screens: {
              [SCREENS.EventDetails]: PATHS.EventDetails,
              [SCREENS.TicketList]: PATHS.TicketList,
              [SCREENS.Cart]: PATHS.Cart,
              [SCREENS.Billing]: PATHS.Billing,
              [SCREENS.Checkout]: PATHS.Checkout,
              [SCREENS.Payment]: PATHS.Payment,
              [SCREENS.OrderDetails]: PATHS.OrderDetails,
            },
          },
          [SCREENS.ScannerTab]: {
            path: PATHS.ScannerTab,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            initialRouteName: SCREENS.Scanner,
            screens: {
              [SCREENS.Scanner]: PATHS.Scanner,
            },
          },
          [SCREENS.SettingsTab]: {
            path: PATHS.SettingsTab,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            initialRouteName: SCREENS.Settings,
            screens: {
              [SCREENS.Settings]: PATHS.Settings,
              [SCREENS.TerminalSettings]: PATHS.TerminalSettings,
              [SCREENS.VenueSettings]: PATHS.VenueSettings,
            },
          },
        },
      },
      [SCREENS.TicketDetails]: PATHS.TicketDetails,
    },
  },
};
